import { CollapseListItem } from 'types/commons';

const list: CollapseListItem[] = [
  {
    key: '1',
    label: 'What makes Joblio unique?',
    content: (
      <>
        Our modern and collaborative approach to staffing means we align with
        your goals by investing in the long-term success of the employees we
        place. It’s why we focus on retention more than any other provider of
        human capital. We also eliminate shady middlemen, bringing compliance
        and fairness to vulnerable workers and employers through an ethical,
        transparent and compliant migrant process.
      </>
    )
  },
  {
    key: '2',
    label: 'How does Joblio find talent?',
    content: (
      <>
        Through deep relationships with organizations trusted by refugees,
        immigrants, economic migrants and community leaders, Joblio has access
        to a global network of qualified laborers with a wide range of skills.
        Our partners include The Shapiro Foundation, HIAS, Jewish Family
        Services and Journey’s End Refugee Services.
      </>
    )
  },
  {
    key: '3',
    label: 'What types of workers can Joblio provide?',
    content: (
      <>
        We specialize in finding workers who are already skilled in the trades,
        manufacturing, construction, roofing and automotive, as well as
        maintenance, landscaping, food processing and hospitality, among others.
      </>
    )
  },
  {
    key: '4',
    label: 'How do employers pay?',
    content: (
      <>
        Employers have many different service models to choose from:
        <ul>
          <li>Applicant Concierge Experience (ACE)</li>
          <li>Temporary</li>
          <li>Contract</li>
          <li>Direct hire</li>
          <li>On-site partnership</li>
        </ul>
        Joblio only gets paid when your employee stays, ensuring we’re invested
        in long-term retention. The more your employee succeeds for you, the
        more we succeed. And we support you in keeping the great employees you
        find through our proprietary support program.
      </>
    )
  },
  {
    key: '5',
    label: 'How does Joblio approach employee retention?',
    content: (
      <>
        Our exclusive Applicant Concierge Experience is an extended HR service
        that creates retention by supporting employees placed by Joblio. The ACE
        program ensures effective onboarding and provides wrap-around assistance
        that meets the unique needs of each worker. Participation in ACE leads
        to 93% retention rates after six months.
      </>
    )
  }
];

export default list;
